import React from 'react';
import { Topic, Package } from '../../types';

interface Props {
  isLoading: boolean;
  selectedPackage: Package | null;
  topics: Topic[];
  selectedTopicId: string | null;
  onSelect: (topic: Topic) => void;
  onAdd: () => void;
  onEdit: (topic: Topic) => void;
  onDelete: (topicId: string) => void; // Prop mới
}

const TopicListPanel: React.FC<Props> = ({ isLoading, selectedPackage, topics, selectedTopicId, onSelect, onAdd, onEdit, onDelete }) => {
  if (!selectedPackage) {
    return <div className="panel-placeholder">Select a package to see its topics.</div>;
  }
  return (
    <div className="studio-list-panel">
      <h3>Topics in "{selectedPackage.name}"</h3>
      {isLoading ? <div className="loading-spinner"></div> : (
        <>
          <ul className="studio-list">
            {topics.map(topic => (
              <li key={topic.id} className={`studio-list-item ${topic.id === selectedTopicId ? 'active' : ''}`} onClick={() => onSelect(topic)}>
                <span>{topic.name}</span>
                <div className="item-actions">
                  <button className="btn-edit" onClick={(e) => { e.stopPropagation(); onEdit(topic); }}>Edit</button>
                  {/* Nút Delete mới */}
                  <button className="btn-delete" onClick={(e) => { e.stopPropagation(); onDelete(topic.id); }}>&times;</button>
                </div>
              </li>
            ))}
          </ul>
          <button className="btn btn-add" onClick={onAdd} disabled={!selectedPackage}>+ New Topic</button>
        </>
      )}
    </div>
  );
};

export default TopicListPanel;